// npm package name for Forge
export const FORGE_NPM_PACKAGE_NAME = "forgecode";
